import { render, staticRenderFns } from "./MemberRegister.vue?vue&type=template&id=8ddb2880&scoped=true&"
import script from "./MemberRegister.vue?vue&type=script&lang=js&"
export * from "./MemberRegister.vue?vue&type=script&lang=js&"
import style0 from "./MemberRegister.vue?vue&type=style&index=0&id=8ddb2880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddb2880",
  null
  
)

export default component.exports